var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('import-card',{attrs:{"is-external-request":_vm.managedExternaly,"extra-headers":_vm.headers,"extended-message":_vm.extendedMessage,"allowed-object-type":_vm.getObjectType,"hide-generate-template":""}})}
var staticRenderFns = []

export { render, staticRenderFns }